import React, { useEffect, useState } from "react";
import WithAuth from "../../hoc/WithAuth";
import TableAction from "../../components/TableAction";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";
import {
  Button,
  Checkbox,
  Collapse,
  FloatButton,
  Input,
  Popover,
  Table,
} from "antd";
import { useNavigate } from "react-router-dom";
import { useGetInputPrice } from "../../api/admin";
import OutputPriceModal from "../../components/modals/OutputPriceModal";
import { getStatusColor } from "../../util/statusColor";
import InputPriceModal from "../../components/modals/InputPriceModal";
import { MoreOutlined, PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

function InputPricePage() {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState<any[]>([]);
  const [selectedId, setSelectedId] = useState<number | undefined>();
  const [open, setOpen] = useState(false);
  const [viewAll, setViewAll] = useState(false);
  const { user } = useAuth() as AuthContextValue;
  const [searchText, setSearchText] = useState("");
  const { data, isLoading } = useGetInputPrice();
  const [inputPrice, setInputPrice] = useState<any[]>([]);

  useEffect(() => {
    if (data && data.data && data.data.data && data.data.data.length > 0) {
      const prices = data.data.data.map((item: any) => {
        return {
          id: item.id,
          input: item.input.inputName,
          centerNo: item.warehouse.centerNo,
          inputPrice: item.inputPrice,
          effectiveDate: item.effectiveDate,
          status: item.status === "1" ? "ACTIVE" : "INACTIVE",
        };
      });

      setInputPrice(prices);
    }
  }, [data]);

  useEffect(() => {
    if (searchText) {
      const _data = inputPrice.filter(
        (item: any) =>
          item.input?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.centerNo?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.status?.toLowerCase().includes(searchText.toLowerCase())
      );
      setTableData(_data);
    } else {
      if (inputPrice) {
        setTableData(inputPrice);
      }
    }
  }, [searchText, inputPrice]);

  const handleCreate = () => {
    setOpen(true);
  };

  const columns = [
    {
      dataIndex: "input",
      title: "Input",
    },
    {
      dataIndex: "centerNo",
      title: "Warehouse Code",
    },
    {
      dataIndex: "inputPrice",
      title: "Input Price (ETB)",
    },
    {
      dataIndex: "effectiveDate",
      title: "Effective Date",
      render: (date: number) => (
        <div>
          {dayjs(new Date(date).toLocaleDateString()).format("MMM-DD-YYYY")}
        </div>
      ),
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (status: string, record: any) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: 100,
              paddingTop: 6,
              paddingBottom: 6,
              borderRadius: 8.5,
              color: getStatusColor(status),
              backgroundColor: `${getStatusColor(status)}44`,
            }}
          >
            {status}
          </div>
        );
      },
    },
  ];

  const dangerColumns = [
    {
      dataIndex: "id",
      title: "Actions",
      render: (id: number) => {
        return (
          <Button
            type="primary"
            onClick={() => {
              setSelectedId(id);
              setOpen(true);
            }}
          >
            Edit
          </Button>
        );
      },
    },
  ];

  const hideModal = () => {
    setSelectedId(undefined);
    setOpen(false);
  };

  return (
    <>
      <div className="hidden md:block rounded-xl mt-[25px] px-[50px] pt-[22px] bg-white">
        <InputPriceModal
          open={open}
          selectedId={selectedId}
          hideModal={hideModal}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: 80,
            backgroundColor: "#EEF3F8",
            borderRadius: 8.4,
            marginBottom: 12,
          }}
        >
          <TableAction
            setSearchText={setSearchText}
            onCreateNew={
              user?.roleName === "ROLE_KFT_SUPER_ADMIN"
                ? handleCreate
                : undefined
            }
          />
        </div>

        <Table
          style={{ cursor: "pointer" }}
          dataSource={tableData}
          columns={
            user?.roleName === "ROLE_KFT_SUPER_ADMIN"
              ? [...columns, ...dangerColumns]
              : columns
          }
          loading={isLoading}
        />
      </div>

      <div className="w-full grid grid-col md:hidden px-2 mb-4">
        <div className="text-white sticky top-0">
          <Input
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search"
            style={{ backgroundColor: "#08453E", color: "white", height: 40 }}
          />
        </div>
        <div className="w-full flex justify-between items-center mt-4 mb-2">
          <div className="flex text-white text-xl">
            Inputs ({tableData.length || 0})
          </div>
          {tableData.length > 5 && (
            <div className="">
              <Checkbox onChange={(val: any) => setViewAll(val.target.checked)}>
                View All
              </Checkbox>
            </div>
          )}
        </div>
        {tableData &&
          tableData
            .slice(0, viewAll ? tableData.length : 5)
            .map((item: any) => {
              return (
                <Collapse
                  className="mb-2"
                  accordion
                  items={[
                    {
                      key: item.id,
                      label: `${item.centerNo} - ${item.input}`,
                      children: (
                        <div className="flex justify-between items-center">
                          <div className="flex flex-col">
                            <div>Input price - {item.inputPrice}</div>
                            <div>Effective date - {item.effectiveDate}</div>
                            <div
                              className="w-[150px] flex justify-center items-center rounded-xl py-2 px-4"
                              style={{
                                color: getStatusColor(item.status),
                                backgroundColor: `${getStatusColor(
                                  item.status
                                )}44`,
                              }}
                            >
                              {item.status}
                            </div>
                          </div>
                          <Button
                            onClick={() => {
                              setSelectedId(item.id);
                              setOpen(true);
                            }}
                          >
                            Edit
                          </Button>
                        </div>
                      ),
                    },
                  ]}
                />
              );
            })}
      </div>
    </>
  );
}

export default WithAuth(InputPricePage);
